export const CACHE = { height: 200 };
export const SCROLL_EVENT_OPTIONS = {
  passive: true,
  capture: true,
};
export const SCROLL_EVENT = "scroll";
export const SCROLL_THROTTLE_DELAY = 50;
export const MAX_LIMIT_MULTIPLIER = 4;
export const DEFAULT_LIMIT_MULTIPLIER = 2;
